import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext.jsx';
import { isAdminRole } from '@/lib/authToken';
import SEO from '@/components/SEO';

export default function ProtectedAdminRoute({ children }) {
  const { currentUser, isAuthenticated } = useAuth();
  const location = useLocation();

  if (!isAuthenticated || !isAdminRole(currentUser?.role)) {
    return (
      <>
        <SEO
          title="Login Required | OmNivaas Admin"
          description="This private OmNivaas admin page requires secure login."
          path={location.pathname}
          robots="noindex,nofollow"
        />
        {typeof window !== 'undefined' && (
          <Navigate to="/login" state={{ from: location }} replace />
        )}
      </>
    );
  }

  return children;
}
